import { Navbar } from "components/Navbar";
import { SearchBoxV2 } from "components/Search";
import { useUser } from "hooks/user";
import Head from "next/head";
import React, { PropsWithChildren, useState } from "react";
import { Course, CourseLocationType } from 'models/course'
// import { courseList } from "pages/api/courses";
import { useRouter } from "next/router";
import { createAuthorizedFetch } from "api/fetch";
import { getRequestTokenPair } from "api/auth";
import { fetchCurrentUser } from "api/user";
import { COURSES_ATTENDING_ENDPOINT, COURSES_ENDPOINT } from "api/endpoints";
import { GetServerSideProps } from "next";
import Markdown from "react-markdown";
// import { courseDTFormat } from "./[id]";
import { declOfNum } from "utils/number";
import { handleFetchError } from "utils/fetch";
import Footer from "components/Footer";
import classNames from "classnames";



type CourseProps = PropsWithChildren<{
  id: string
  name: string
  locationType: CourseLocationType
  location?: string
  timestamp?: string
  endTimestamp?: string
  isAttending?: boolean
  special?: boolean
}>

export function CourseItem(props: CourseProps) {
  const router = useRouter()
  const handleClick = () => {
    console.log('/courses/' + props.id)
    router.push('/courses/' + props.id)
  }

  const courseDTFormat = Intl.DateTimeFormat('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
  })

  return <div className={classNames("rounded-xl p-1 flex flex-col justify-between gap-1 border hover:cursor-pointer hover:-translate-y-0.5 transition-transform duration-300", {
    "border-light-grey": !props.special,
    "border-emerald-500 border-[3px] ": !!props.special,
  })}
    style={{ height: 300 }}
    onClick={handleClick}>
    <span className="flex flex-col gap-1 h-full justify-between">
      <h1 className="text-xl font-semibold break-words line-clamp-3 overflow-ellipsis" title={props.name}>{props.name}</h1>
      <span className="flex flex-col gap-0.5 justify-end text-semidark-grey">
        <div className="flex flex-row gap-0.5 items-center">
          {props.locationType === CourseLocationType.ONLINE ? <>
            <img src="/images/link-new-smgrey.svg" className="w-1 h-1" />
            <a className="text-secondary underline text-ellipsis overflow-x-hidden" href={(props.location!.startsWith('http://') || props.location!.startsWith('https://')) ? props.location! : '#'}>{props.location!}</a>
          </> : props.locationType === CourseLocationType.OFFLINE ? <>
            <img src="/images/courses/location-grey.svg" className="w-1 h-1" />
            <p className="text-ellipsis overflow-x-hidden">{props.location!}</p>
          </> : <></>}
        </div>
        {props.locationType !== CourseLocationType.VIDEO && <div className="flex flex-row gap-0.5 items-center">
          <img src="/images/courses/time-grey.svg" className="w-1 h-1" />
          <p>{courseDTFormat.format(new Date(props.timestamp!))} - {courseDTFormat.format(new Date(props.endTimestamp!))}</p>
        </div>}
      </span>
    </span>
    {props.isAttending && <span className="flex flex-col gap-0.5">
      <hr />
      <div className="w-full flex justify-between gap-2 h-1">
        {props.isAttending && <span className="text-sm py-[1px] px-[5px] border border-emerald-400 rounded-full text-emerald-400">Вы записаны</span>}
      </div>
    </span>}
  </div>
}


export const getServerSideProps: GetServerSideProps = async (context) => {
  const apiFetch = createAuthorizedFetch(getRequestTokenPair(context.req)?.accessToken)

  const courses = await (await fetch(COURSES_ENDPOINT)).json()
  let attending: string[]
  try {
    attending = await (await handleFetchError(apiFetch(COURSES_ATTENDING_ENDPOINT))).json() as string[]
  } catch (e) {
    attending = []
  }



  return {
    props: {
      courses,
      attending,
    }
  }
}


export default function Courses({ courses: courseList, attending }: { courses: Course[]; attending: string[] }) {
  const [user] = useUser()
  const [searchQuery, setSearchQuery] = useState<string>('')
  return <>
    <Head>
      <title>Курсы</title>
    </Head>
    <div>
      <Navbar user={user} static />
      <div className="w-full flex flex-col items-center gap-2 pb-4">
        <div className="flex flex-col items-center gap-2 w-full p-6" style={{
          backgroundImage: 'url(/images/courses/banner_clean_v2.png)',
          backgroundPositionY: '30%',
          backgroundPositionX: '70%',
          backgroundSize: '100% auto',
        }}>
          <div className="flex flex-col gap-2 w-50 3xl:w-70">
            <h1 className="text-4xl font-semibold">Курсы <span className="text-secondary">Research Helper</span></h1>
            <p className="text-xl" style={{ maxWidth: 800 }}>
              Раздел содержит все необходимое для авторов научных публикаций —
              от&nbsp;начинающих исследователей до опытных авторов,
              публикующихся в ВАК, РИНЦ, RSCI, WoS и Scopus. Курсы охватывают
              ключевые аспекты подготовки статей, работы с рецензентами,
              соблюдения публикационной этики и повышения цитируемости.
              Доступны практические рекомендации по научному стилю, разбор
              правок и подготовка рукописей к подаче в ведущие журналы.
              {/* Lorem ipsum dolor sit amet consectetur. Aliquam adipiscing vel eget mi. Ornare etiam non porta molestie nullam nam lectus nunc odio. */}
              <br /><br />
              Также здесь представлены интерактивные материалы, тесты и кейсы, охватывающие
              терапию и профилактическую медицину, организацию здравоохранения и цифровые технологии.
              Доступны инструменты для отслеживания прогресса и сертификации.
            </p>
          </div>
        </div>
        <SearchBoxV2 query={searchQuery} setQuery={setSearchQuery} placeholder="Найти курс" style={{ width: 1000 }} childClassName="py-0.5 rounded-2xl px-1" />
        <div className="grid grid-cols-3 gap-2 w-50 3xl:w-70">
          {courseList.sort((a, b) => (b.timestamp && a.timestamp) ? new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime() : -1) // TODO: Course.created_at
            .sort((a, b) => {
              if (a.priority && b.priority) return a.priority - b.priority
              if (a.priority) return -1
              if (b.priority) return 1
              return 0
            }).filter(v => {
              if (searchQuery === '')
                return true
              const q = searchQuery.toLocaleLowerCase()

              if (v.name.toLocaleLowerCase().includes(q))
                return true
              // if (v.short_description.toLocaleLowerCase().includes(q))
              //   return true

              return false
            }).map(v =>
              <CourseItem key={v.id} id={v.id!} name={v.name} isAttending={attending.includes(v.id!)} location={v.location} timestamp={v.timestamp} endTimestamp={v.end_timestamp} locationType={v.location_type} special={v.special} />
            )}
        </div>
      </div>
      <Footer />
    </div>
  </>
}
